import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useGetBenefitQuery } from '../../apis/cmsApi/cms.hooks.api';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';

import './BenefitsView.css';

type BenefitsViewProps = {};

export const BenefitsView: React.FC<BenefitsViewProps> = () => {
  const languageSettings = useLanguage();
  const t = languageSettings[0];
  const locale = languageSettings[2];
  const back = useBack();

  const { data: benefit } = useGetBenefitQuery({
    locale,
  });

  return (
    <BaseLayout hasBack onBackClick={back} title={t('pageTitles.benefits')}>
      {benefit && <ReactMarkdown>{benefit.content}</ReactMarkdown>}
    </BaseLayout>
  );
};
